import { Context, CustomQuery } from '@vue-storefront/core';
import { WayBillItem, WayBillItems, ApiResult } from '../../types';

export default async function wayBillList({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/waybill/list', config.api.url);
  const { data: res } = await client.post(url.href, params);
  const list: WayBillItems = [];
  if (res.data && res.data.list) {
    res.data.list.forEach((x) => {
      const address: WayBillItem = {
        Id: x.id,
        orderId: x.order_id,
        shopId: x.shop_id,
        shippingCode: x.shipping_code,
        shippingCorp: x.shipping_corp,
        isMain: x.is_main,
        sort: x.sort,
        data: x.data,
        createTime: x.create_time,
        details: x.details
      };
      list.push(address);
    });
  }
  res.data = list;
  return res;
}
